import {App as StdApp} from "@std/app";

export class App extends StdApp {
    constructor(config = {}) {
        super(config);
    }

    run() {}
}

import "@main/components/burger-menu";
import "@main/components/toggle-sublist";
import "@main/components/accordion";
import "@main/components/sliders/";
import "@main/components/show-all-elements";
import "@main/components/map";
import "@main/components/perfect-scroll";
import "@main/components/open-modal";
import "@main/components/form/";
import "@main/components/representatives";
import "@main/components/publication/publications-slider";
import "@main/components/select";
import "@main/components/course-card-detailed";